/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Tab_FeaturedInputs */

const en_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const ar_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مميّز`)
};

const de_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlights`)
};

const es_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacados`)
};

const fr_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la une`)
};

const it_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In evidenza`)
};

const ja_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注目`)
};

const ko_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천`)
};

const pt_br_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaques`)
};

const ru_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуем`)
};

const th_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนะนำ`)
};

const tr_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öne Çıkanlar`)
};

const zh_cn_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选`)
};

const zh_tw_store_tab_featured = /** @type {(inputs: Store_Tab_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精選`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Store_Tab_FeaturedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const store_tab_featured = /** @type {((inputs?: Store_Tab_FeaturedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Tab_FeaturedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_store_tab_featured(inputs)
	if (locale === "ar") return ar_store_tab_featured(inputs)
	if (locale === "de") return de_store_tab_featured(inputs)
	if (locale === "es") return es_store_tab_featured(inputs)
	if (locale === "fr") return fr_store_tab_featured(inputs)
	if (locale === "it") return it_store_tab_featured(inputs)
	if (locale === "ja") return ja_store_tab_featured(inputs)
	if (locale === "ko") return ko_store_tab_featured(inputs)
	if (locale === "pt_br") return pt_br_store_tab_featured(inputs)
	if (locale === "ru") return ru_store_tab_featured(inputs)
	if (locale === "th") return th_store_tab_featured(inputs)
	if (locale === "tr") return tr_store_tab_featured(inputs)
	if (locale === "zh_cn") return zh_cn_store_tab_featured(inputs)
	return zh_tw_store_tab_featured(inputs)
});